import ErrorPage1 from "../Component/Pages/OtherPage/ErrorsPages/ErrorPage1.svelte"
import ErrorPage2 from "../Component/Pages/OtherPage/ErrorsPages/ErrorPage2.svelte"
import ErrorPage3 from "../Component/Pages/OtherPage/ErrorsPages/ErrorPage3.svelte"
import ErrorPage4 from "../Component/Pages/OtherPage/ErrorsPages/ErrorPage4.svelte"
import ComingSimple from "../Component/Pages/OtherPage/ComingSoon/ComingSimple.svelte"
import ComingVideo from "../Component/Pages/OtherPage/ComingSoon/ComingVideo.svelte"
import ComingImage from "../Component/Pages/OtherPage/ComingSoon/CommingImage.svelte"
import LoginSimple from "../Component/Pages/OtherPage/Authentication/LoginSimple/LoginSimple.svelte"
import LoginWithBgImage from "../Component/Pages/OtherPage/Authentication/LoginSimple/LoginWithBgImage.svelte"
import LoginWithBgImageTwo from "../Component/Pages/OtherPage/Authentication/LoginSimple/LoginWithBgImageTwo.svelte"
import LoginWithValidation from "../Component/Pages/OtherPage/Authentication/LoginSimple/LoginWithValidation.svelte"
import LoginWithTooltipValidation from "../Component/Pages/OtherPage/Authentication/LoginSimple/LoginWithTooltipValidation.svelte"
import LoginWithSweetAlert from "../Component/Pages/OtherPage/Authentication/LoginSimple/LoginWithSweetAlert.svelte"
import RegisterSimple from "../Component/Pages/OtherPage/Authentication/LoginSimple/RegisterSimple.svelte"
import RegisterWithBgImage from "../Component/Pages/OtherPage/Authentication/LoginSimple/RegisterWithBgImage.svelte"
import RegisterWithBgVideo from "../Component/Pages/OtherPage/Authentication/LoginSimple/RegisterWithBgVideo.svelte"
import UnlockUser from "../Component/Pages/OtherPage/Authentication/LoginSimple/UnlockUser.svelte"
import ForgetPassword from "../Component/Pages/OtherPage/Authentication/LoginSimple/ForgetPassword.svelte"
import CreatPassword from "../Component/Pages/OtherPage/Authentication/LoginSimple/CreatPassword.svelte"
import Maintenance from "../Component/Pages/OtherPage/Authentication/LoginSimple/Maintenance.svelte"
import Login from "../Auth/Login.svelte"

export default [
    { path: '/login', component: Login },
    
    //Errors Pages
    {path:`/errorpage/errorpage1`, component:ErrorPage1},
    {path:`/errorpage/errorpage2`, component:ErrorPage2},
    {path:`/errorpage/errorpage3`, component:ErrorPage3},
    {path:`/errorpage/errorpage4`, component:ErrorPage4},

    //Comming Soon Pages
    {path:`/comingsoon/comingsimple`, component:ComingSimple},
    {path:`/comingsoon/comingwithbgvideo`, component:ComingVideo},
    {path:`/comingsoon/comingwithbgimage`, component:ComingImage},

    // authentication pages
    {path:`/authentication/loginSimple`, component:LoginSimple},
    {path:`/authentication/loginwithbgimage`, component:LoginWithBgImage},
    {path:`/authentication/loginwithimagetwo`, component:LoginWithBgImageTwo},
    {path:`/authentication/loginwithvalidation`, component:LoginWithValidation},
    {path:`/authentication/loginwithtooltip`, component:LoginWithTooltipValidation},
    {path:`/authentication/loginwithsweetalert`, component:LoginWithSweetAlert},
    {path:`/authentication/registersimple`, component:RegisterSimple},
    {path:`/authentication/registerwithbgimage`, component:RegisterWithBgImage},
    {path:`/authentication/registerwithbgvideo`, component:RegisterWithBgVideo},
    {path:`/authentication/unlockuser`, component:UnlockUser},
    {path:`/authentication/forgetpassword`, component:ForgetPassword},
    {path:`/authentication/creatpassword`, component:CreatPassword},
    {path:`/authentication/maintenance`, component:Maintenance}
]